import MypageHomeContainer from './MypageHomeContainer';
export default MypageHomeContainer;
